<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'Fog',
  render: (h) => h(),
  beforeDestroy() {
    this.$scene.fogMode = BABYLON.Scene.FOGMODE_NONE
  },
  created() {
    const scene = this.$parent.$scene
    this.$scene = scene
    const meshs = this.$parent.$meshs

    _.each(meshs, m => {
      if(m.material) {
        m.material.fogEnabled = false

        if(m.name == 'TN_fogContainer_MAT_TN_fogContainer_0')
          m.material.fogEnabled = true

        if(m.name.substring(0, 6) == 'trees_')
          m.material.fogEnabled = true

        if(m.name.substring(0, 4) == 'EXT_')
          m.material.fogEnabled = true

        if(m.name == 'EXT_ground_01_MAT_MR_ground_0') {
          m.material.albedoTexture.uScale = 10
          m.material.albedoTexture.vScale = 10
        }
      }
    })

    scene.fogMode = BABYLON.Scene.FOGMODE_LINEAR
    // scene.fogColor = new BABYLON.Color3(1, 0.5, 0.8)
    scene.fogColor = new BABYLON.Color3(.25, 0.5, 0.8)
    scene.fogStart = 200.0
    scene.fogEnd = 800.0
  },
}
</script>



// WEBPACK FOOTER //
// src/components/world/elements/Fog.vue